export default "__VITE_PUBLIC_ASSET__f81ef4d6__"